import {
  RECORD_LOAD,
  RECORD_LOAD_SUCCESS,
  RECORDED_DELETE,
  RECORDED_ADD,
  RECORDED_REMOVE,
  RECORDED_REFRESH,
  RECORD_ACTION_SUCCESS,
  RECORD_ACTION_ERROR,
  RECORDED_GET,
  RECORDED_GET_SUCCESS,
  RECORDED_GET_CLEAR
} from "./actions";
import {
  GUIDE_LOAD_SUCCESS,
  STREAM_LOAD_CHANNEL_SUCCESS
} from "../../redux-root/actions";

const initialState = {
  planData: null,
  recordData: null,
  recordAction: true,
  actionError: false,
  timeSlotData: null
};

export function recordReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case RECORD_LOAD:
      return {
        ...state,
        planData: null,
        recordData: null
      };

    case RECORD_LOAD_SUCCESS:
      return {
        ...state,
        planData: data.plan,
        recordData: data.recordData
      };

    case RECORDED_DELETE:
    case RECORDED_ADD:
    case RECORDED_REMOVE:
    case RECORDED_REMOVE:
      return {
        ...state,
        recordAction: false,
        actionError: false
      };

    case RECORD_ACTION_SUCCESS:
      return {
        ...state,
        recordData: data,
        recordAction: true
      };

    case RECORD_ACTION_ERROR:
      return {
        ...state,
        recordAction: true,
        actionError: true
      };

    case GUIDE_LOAD_SUCCESS:
    case STREAM_LOAD_CHANNEL_SUCCESS:
      return {
        ...state,
        planData: action.plan,
        recordData: action.recorded
      };

    case RECORDED_GET:
    case RECORDED_GET_CLEAR:
      return {
        ...state,
        timeSlotData: null
      };

    case RECORDED_GET_SUCCESS:
      return {
        ...state,
        timeSlotData: data
      };

    default:
      return state;
  }
}
